import { useSyncExternalStore } from 'react';

export type Route =
  | { name: 'home' }
  | { name: 'meeting'; id: string; passcode: string | null }
  | { name: 'not-found' };

function parse(): Route {
  const { pathname, search } = location;
  if (pathname === '/' || pathname === '') return { name: 'home' };
  const m = pathname.match(/^\/j\/(\d{10})\/?$/);
  if (m) return { name: 'meeting', id: m[1], passcode: new URLSearchParams(search).get('pwd') };
  return { name: 'not-found' };
}

let current = parse();
const listeners = new Set<() => void>();
const emit = () => {
  current = parse();
  listeners.forEach((l) => l());
};
window.addEventListener('popstate', emit);

export function navigate(to: string, { replace = false } = {}): void {
  if (replace) history.replaceState(null, '', to);
  else history.pushState(null, '', to);
  emit();
}

export function useRoute(): Route {
  return useSyncExternalStore(
    (l) => {
      listeners.add(l);
      return () => listeners.delete(l);
    },
    () => current,
  );
}
